/**
 * Information about user permission codes can be found here:
 * https://humanproject.atlassian.net/wiki/spaces/RS/pages/265814183/Site+Architecture+and+Permissions
 */

export const PERMISSION_FOR_VIEWING_PARTICIPANT_VISITS = ['wpv', 'rpv', 'rppv', 'rppv-no-pii', 'rpc']
